import React, { useEffect, useRef, useState } from 'react';

import AdTest from './AdTest';
import FormContainer from './FormContainer';
import { loadFormCallback, whenReady, whenRenderedCallback } from './formEvents';
import * as styles from './MarketoForm.module.scss';

let checkTime = 500;
let maxTries = 20;

const EmbeddedMarketoForm = ({ formId, onSuccess, slug, className }) => {
  const [formLoaded, setFormLoaded] = useState(false);
  const [formUnavailable, setFormUnavailable] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const intervalId = useRef(null);
  const tries = useRef(0);

  // Check for mktoFrms2 at intervals
  useEffect(() => {
    intervalId.current = setInterval(() => {
      // If max tries reached and mktoFrms2 not available, stop checking and set form as unavailable
      if (tries.current === maxTries && !window.MktoForms2) {
        clearInterval(intervalId.current);
        if (typeof window !== 'undefined' && !!window.FS) {
          window.FS.event('Marketo Form', {
            type: 'Form failed to load',
            formID: (formId && formId.toString()) || '',
          });
        }
        setFormUnavailable(true);
        return;
      }

      tries.current++;

      // If mktoFrms2 is available, stop checking and set script as loaded
      if (typeof window !== 'undefined' && !!window.MktoForms2) {
        setScriptLoaded(true);
        clearInterval(intervalId.current);
      }
    }, checkTime);
    // Clear interval when component unmounts
    return () => clearInterval(intervalId.current);
  }, []);

  // Load form when script is loaded
  useEffect(() => {
    if (typeof window !== 'undefined' && scriptLoaded && !formLoaded) {
      window.MktoForms2?.loadForm(process.env.GATSBY_FORM_HOST, '002-LDF-436', formId, (form) => {
        loadFormCallback(form, true, onSuccess, slug);
      })
        .whenReady(async (form) => {
          await whenReady(form, false, 0);
          setFormLoaded(true);
        })
        .whenRendered((form) => {
          whenRenderedCallback(form);
        });
    }
  }, [scriptLoaded]);

  // If form is unavailable, render AdTest component
  if (formUnavailable) {
    return <AdTest formId={formId} formLoadFailed={formUnavailable} />;
  }

  // Determine fade style based on whether form is loaded
  const fade = formLoaded ? styles.fadeIn : styles.fadeOut;
  return (
    <>
      {!formLoaded && <span key="loading-spinner" className={styles.spinner} />}
      <FormContainer className={[fade, className].join(' ')} formId={formId} fade={true} />
    </>
  );
};

export default EmbeddedMarketoForm;
